import { Stepper, Step, StepLabel } from '@material-ui/core';

import { Typography } from '@components';
import { useStyles } from './DeploymentModalStepper.styles';
import { UPCOMING_STEP_ICON } from './DeploymentModalStepper.const';
import { DeploymentModalStepperProps } from './DeploymentModalStepper.types';

export const DeploymentModalStepper = ({ step, steps }: DeploymentModalStepperProps): JSX.Element => {
  const styles = useStyles();

  const renderStepIcon = (index: number) => (
    <Typography.Body className={styles.stepIcon} {...(index > step ? UPCOMING_STEP_ICON : null)}>
      {index + 1}
    </Typography.Body>
  );

  return (
    <Stepper className={styles.stepper} activeStep={step}>
      {steps.map((item, index) => (
        <Step className={styles.step} active={index === step} completed={false} disabled={false} key={item.label}>
          <StepLabel icon={renderStepIcon(index)}>
            <Typography.Body>{item.label}</Typography.Body>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
